import { sortArray } from '@nu-art/ts-common';
export const SearchSorter_Label = {
    key: 'label',
    sortFunction: (results) => {
        sortArray(results, result => result.filterResults[SearchSorter_Label.key].value);
    }
};
//# sourceMappingURL=SearchSorter_Label.js.map